<template>
  <div class="row">
    <div v-show="items.length > 0" class="col-xs-12">
      <div class="form-field">
        <input-field
          :id="'checkedListboxSearch' + field"
          v-model="search"
          placeholder="Escribe tu consulta..."
        >Buscar</input-field>
      </div>
    </div>
    <div v-show="items.length > 0" class="col-xs-12">
      <p>
        <label :for="'seleccionarTodo' + field">
          <input
            @change="seleccionarTodos"
            v-model="todos"
            type="checkbox"
            :id="'seleccionarTodo' + field"
          />
          <span>Seleccionar todo</span>
        </label>
      </p>
    </div>
    <div
      v-show="similiarToSearch(item[label])"
      :key="index"
      v-for="(item, index) in items"
      class="col-xs-12 col-md-6"
    >
      <label :for="name.toString() + index.toString()">
        <input
          @change="$emit('input', modelValue)"
          v-model="modelValue"
          :value="item[field]"
          type="checkbox"
          :name="name"
          :id="name.toString() + index.toString()"
        />
        <span>{{ item[label] }}</span>
      </label>
    </div>
    <div v-show="items.length === 0" class="col-xs-12">
      <p>No hay registros.</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Number,
      required: false,
      default: 2
    },
    name: {
      type: String,
      required: false,
      default: ""
    },
    items: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    },
    value: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    label: {
      type: String,
      required: false,
      default: "descripcion"
    },
    field: {
      type: String,
      required: false,
      default: "id"
    }
  },
  data: function() {
    return {
      search: "",
      modelValue: JSON.parse(JSON.stringify(this.value)),
      todos: false
    };
  },
  methods: {
    similiarToSearch: function(value) {
      if (this.search === "") return true;
      else return value.toUpperCase().indexOf(this.search.toUpperCase()) != -1;
    },
    seleccionarTodos: function() {
      this.modelValue.splice(0, this.modelValue.length);
      if (this.todos) {
        for (let i = 0; i < this.items.length; i++)
          this.modelValue.push(this.items[i][this.field]);
      }
      this.$emit("input", this.modelValue);
    }
  },
  watch: {
    value: function(value) {
      this.modelValue = value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/CheckedListbox.vue